// العربية - ar - 阿拉伯语
const ar = {
  home: {
    home: 'الرئيسية',
    solutions: 'الحلول',
    support: 'الدعم',
    news: 'الأخبار',
    aboutUs: 'معلومات عنا',
    contactUs: 'اتصل بنا',
    cgm: 'CGM',
    download: 'التنزيلات',
    helpCenter: 'مركز المساعدة',
    copyText: '© 2026 هيبو ميديكال بي تي إي. المحدودة. جميع الحقوق محفوظة.',
    menu: 'القائمة',
    quickLinks: 'روابط سريعة',
    contact: 'اتصال',
    legal: 'نشرة قانونية',
    termsUse: 'شروط الاستخدام',
    privacyPolicy: 'سياسة الخصوصية',
    portal: 'بوابة المستخدم',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'الرسائل',
    subscribe: 'اشتراك',
    signUp: 'قم بالتسجيل لتلقي آخر الأخبار',
    downloadApp: 'تحميل التطبيق',
    blogNews: 'المدونة والأخبار',
    latestArticles: 'أحدث المقالات',
    viewAllArticles: 'عرض جميع المقالات',
    empower: 'عزز رحلتك الصحية معنا',
    empowerList1Content:
      'لقد جعل Hippo CGM إدارة مرض السكري لدى ابني أسهل بكثير. يمكننا استخدام HIPPOLINK لرؤية أنماط الجلوكوز لديه بوضوح وضبط رعايته بثقة. إنه يمنحنا راحة البال.',
    empowerList1Name:
      'بيترا ن.، جمهورية التشيك (أم لطفل مصاب بداء السكري من النوع الأول)',
    empowerList2Content:
      'لقد أوصينا المرضى هنا باستخدام HIPPO CGM لأدائه المستقر ووقت ارتدائه الأطول. لقد كانت تعليقات المستخدمين ممتازة، خاصة من أولئك الذين يبحثون عن خيار أقل تكلفة.',
    empowerList2Name: 'دكتور لوكا ب.، أخصائي الغدد الصماء، إيطاليا',
    empowerList3Content:
      'لقد بدأت باستخدام Hippo CGM مؤخرًا - فهو مريح ودقيق وقد ساعدتني التنبيهات على تجنب انخفاض مستوى الجلوكوز أثناء الليل. سعيد جدًا بالنتائج حتى الآن.',
    empowerList3Name:
      'فهد أ.، المملكة العربية السعودية (مريض السكري من النوع الثاني)',
    reliable: 'شريكك الموثوق في إدارة مرض السكري',
    hippoH1: 'HiPPO H1',
    challenges: 'التحديات',
    constant: 'المراقبة المستمرة لسكر الدم',
    traditional:
      'يمكن أن يكون وخز الإصبع التقليدي لفحص نسبة الجلوكوز في الدم مؤلمًا وغير مريح',
    dataOverload: 'التحميل الزائد للبيانات',
    managing:
      'قد تكون إدارة بيانات نسبة السكر في الدم من مصادر متعددة أمرًا صعبًا ويصعب تفسيره',
    treatment: 'تعديلات العلاج',
    accurately:
      'يمكن أن يكون التحديد الدقيق لمسار العمل الصحيح بناءً على قراءات نسبة السكر في الدم أمرًا معقدًا',
    lifestyle: 'تكامل نمط الحياة',
    balancing:
      'يمكن أن تشكل الموازنة بين الوجبات وممارسة الرياضة والأدوية مع الأنشطة اليومية تحديًا',
    hippoCan: 'يوفر تطبيق Hippo Biosensors',
    painless: 'مراقبة غير مؤلمة وسرية',
    ourCgm:
      'يوفر CGM الخاص بنا قراءات مستمرة لسكر الدم دون الحاجة إلى وخز الإصبع',
    realTime: 'البيانات والرؤى في الوقت الحقيقي',
    accessYour:
      'يمكنك الوصول إلى بيانات نسبة السكر في الدم بسهولة على هاتفك الذكي، مما يسمح لك برؤية الاتجاهات واتخاذ قرارات مستنيرة',
    personalized: 'دعم مخصص',
    ourCgmSys:
      'يمكن أن تساعدك التنبيهات والتذكيرات من تطبيق Hippo BioSensors على البقاء على المسار الصحيح مع خطة العلاج الخاصة بك.',
    improved: 'تحسين عملية صنع القرار',
    gain: 'فهم أعمق لكيفية استجابة جسمك للأحداث، مما يمكّنك من تعويض تقلبات الجلوكوز بشكل أفضل. تسمح لك التعليقات في الوقت الفعلي بإجراء تعديلات على أنشطتك اليومية بشكل أكثر فعالية.',
    // about: 'معلومات', // ai翻译
    companyProfile: 'الملف التعريفي للشركة',
    banner1Title: 'مرحبا بكم في Hippo Medical',
    banner1Content: 'في طليعة ابتكارات CGM',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'وضع معايير جديدة في تكنولوجيا CGM.',
    banner3Content: 'حماية الجلوكوز على مدار الساعة.',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'البقاء في طليعة تكنولوجيا CGM',
    // 错误提示
    subscribeSuccess: 'تم الاشتراك بنجاح', // ai翻译
    subscribeFailed: 'فشل الاشتراك', // ai翻译
    invalidEmail: 'عنوان بريد إلكتروني غير صالح', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return ar.home.banner1Title;
    },
    get banner1Content() {
      return ar.home.banner4Content;
    },
    whyChoose: 'لماذا تختار HiPPO CGM',
    accurate: 'دقة يمكنك الوثوق بها',
    accurateText: 'تكنولوجيا الإنزيم من الجيل الثالث تجلب المزيد',
    accurateText1: 'أداء مستقر ودقيق',
    easyUse: 'سهلة الاستخدام',
    easyUseText: '14 يومًا من المراقبة المستمرة',
    realTime: 'مراقبة',
    realTimeText: 'تذكير نقص وارتفاع السكر في الدم في الوقت الفعلي',
    realTimeText1:
      'مشاركة البيانات في الوقت الفعلي مع أفراد العائلة ومقدم الرعاية الصحية',
    hippo: 'HiPPO',
    hCgm: 'H1 سي جي إم',
    keep: 'يبقيكم على اطلاع في أي مكان وزمان',
    withHippo: 'مع تطبيقات HiPPO والبوابة الالكترونية',
    smallSensors: 'أجهزة استشعار صغيرة، ارتداء مريح',
    agpReport:
      'يسمح تقرير AGP المهني لمقدمي الرعاية الصحية والمستخدمين بالتقاط المعلومات الأساسية على الفور',
    unlimitedFollow:
      'متابعة غير محدودة، لتمكين مقدمي الرعاية الصحية من إدارة المزيد من المستخدمين',
    iWatchApp: 'يتوفر تطبيق iWatch',
    certified: 'استخدام معتمد للأطفال',
    loremIp:
      'تم التحقق من صحة النظام سريريًا واعتماده رسميًا للاستخدام من قبل الأطفال فوق سن 3 سنوات، مما يضمن السلامة والدقة والراحة للمرضى الأصغر سنًا. بفضل دقة المستشعر المثبتة والمواد اللطيفة والصديقة للبشرة، فإنه يوفر مراقبة موثوقة للجلوكوز لدى الأطفال والمراهقين - مما يدعم متخصصي الرعاية الصحية في تقديم رعاية موثوقة ومبنية على البيانات لمرض السكري.',
  },
  news: {
    date: 'التاريخ',
    recommendedArticles: 'المقالات الموصى بها',
  },
  support: {
    download: 'تحميل الأدلة',
    supportDown: 'الدعم/التنزيلات',
  },
  about: {
    // welcome: 'مرحبا بكم في Hippo Medical', // ai翻译
    // covered: 'البلدان المغطاة', // ai翻译
    // patents: 'براءات الاختراع', // ai翻译
    // features: 'الميزات3', // ai翻译
    // ring: 'الحلقة', // ai翻译
    // apparently:
    // 'حلقة عجيبة يمكنها مراقبة المعلمات مثل الأكسجين في الدم ومعدل ضربات القلب والنوم. والأهم من ذلك، أنها تحتوي على اتصال خوارزمي مع CGM الخاص بنا. سيتم إطلاقها في عام 2026. ترقبوا ذلك!', // ai翻译
    // cgmSky:
    //   'جهاز مراقبة الغلوكوز المستمر الاحترافي مصمم مع مراعاة استخدام المريض واحتياجات الطبيب السريرية. إنه يوفر دقة عالية، وتفاعلًا برمجيًا سهل الاستخدام، ويتم تشغيله بواسطة خوارزميات Hippo Medical. سيتم إطلاقه في يونيو 2025!', // ai翻译
    // smartWatch: 'ساعة ذكية', // ai翻译
    // byTheSame:
    //   'جهاز مراقبة ضغط الدم الديناميكي القابل للارتداء والذي يمكنه تتبع الضغط الانقباضي والضغط الانبساطي ومتوسط الضغط الشرياني والمزيد بشكل مستمر، ويتميز بخوارزمية طورتها شركة Hippo Medical. سيتم إطلاقه في عام 2026. ترقبوا ذلك!', // ai翻译
    explore: 'استكشف',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'سنغافورة(409051)',
    zipCode: 'الرمز البريدي',
    emailCode: '409051',
    email: 'بريد إلكتروني',
    emailText: 'info@hippodiabetes.com',
    name: 'الاسم',
    company: 'الشركة',
    message: 'الرسالة',
    phone: 'الهاتف',
    submit: 'إرسال',
    // commingSoon: 'قريباً', // ai翻译
    cpInfo1:
      'شركة Hippo Medical هي شركة MedTech عالمية، مقرها الرئيسي في سنغافورة، مكرسة لإحداث ثورة في إدارة الأمراض المزمنة باستخدام أجهزة استشعار حيوية يمكن ارتداؤها من الدرجة الطبية. رؤيتنا هي توفير المراقبة المستمرة وتحليل البيانات المتقدمة.',
    cpInfo2:
      'من خلال تطوير أجهزة الاستشعار الحيوية من الجيل التالي ومنصة ذكاء البيانات المتطورة، نهدف إلى تحويل التشخيص وقيادة الطريق إلى مستقبل أكثر استباقية وتخصيصًا.',
    submitFailed: 'فشل الإرسال', // ai翻译
    get invalidEmail() {
      return ar.home.invalidEmail;
    },
    fillAllFields: 'يرجى ملء هذا الحقل', // ai翻译
  },
  download: {
    language: 'اللغة',
    product: 'المنتج',
    unit: 'الوحدة',
    fetchFailed: 'فشل الاسترجاع', // ai翻译
  },
  help: {
    search: 'بحث',
    support: 'الدعم/مركز المساعدة/H1 CGM',
    source: 'موارد HiPPO H1 CGM عبر الإنترنت',
    viewAll: 'عرض الكل',
    insert: 'كيفية إدخال H1 CGM الخاص بك',
    setUp: 'كيفية إعداد تطبيق H1',
    faq: 'الأسئلة الشائعة حول HiPPO H1 CGM',
    freq: 'الأسئلة الشائعة',
    noData: 'لم يتم العثور على محتوى..',
    searchKeys: {
      warmUp: 'فشل مرحلة الاحماء',
      waterLeakage: 'تسرب المياه',
      lowGlucose: 'بيانات انخفاض الجلوكوز',
      cannotPair: 'لا يمكن إقران الجهاز مع هاتفي الذكي',
    },
  },
  faq: {
    faq: 'التعليمات',
    general: 'أسئلة عامة',
    need: 'بحاجة الى مساعدة في شيء؟',
    here: 'فيما يلي الأسئلة الأكثر شيوعًا لدينا',
    technical: 'الأسئلة الفنية',
  },
  lang: {
    chooseCountry: 'اختر بلدك/منطقتك',
    northAmerica: 'أمريكا الشمالية', // ai翻译
    southAmerica: 'أمريكا الجنوبية', // ai翻译
    europe: 'أوروبا', // ai翻译
    africa: 'أفريقيا', // ai翻译
    asia: 'آسيا', // ai翻译
    oceania: 'أوقيانوسيا', // ai翻译
    other: 'أخرى', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'سوتشو، الصين',
      subName: 'موقع التصنيع',
      hovData:
        'يغطي مكتب مبيعات مركز البحث والتطوير/مركز البيانات الرئيسي العالمي آسيا وأستراليا',
    },
    dubai: {
      name: 'دبي',
      subName: 'المكتب الإقليمي',
      hovData: 'فريق مبيعات المقر الرئيسي لجنوب شرق آسيا',
    },
    singapore: {
      name: 'سنغافورة',
      subName: 'المقر الرئيسي',
      hovData: 'فريق مبيعات جنوب شرق آسيا',
    },
    sanFrancisco: {
      name: 'سان فرانسيسكو، الولايات المتحدة الأمريكية',
      subName: 'المكتب الإقليمي',
      hovData: 'فريق مبيعات المقر الرئيسي لأمريكا الشمالية',
    },
    barcelona: {
      name: 'برشلونة',
      subName: 'مكتب المبيعات',
      hovData:
        'يغطي مكتب مبيعات مركز البحث والتطوير/مركز البيانات الرئيسي العالمي آسيا وأستراليا',
    },
  },
};
export default ar;
